import { connect } from "react-redux";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

import OutlineList from "./OutlineList";

function mapStateToProps(state) {
  return {
    isGreaterThanMedium: selectIsGreaterThanMedium(state)
  };
}

export default connect(mapStateToProps)(OutlineList);
